import { render, staticRenderFns } from "./StudentDetailUpdatesPending.vue?vue&type=template&id=a5f7e8b2&scoped=true&"
import script from "./StudentDetailUpdatesPending.vue?vue&type=script&lang=js&"
export * from "./StudentDetailUpdatesPending.vue?vue&type=script&lang=js&"
import style0 from "./StudentDetailUpdatesPending.vue?vue&type=style&index=0&id=a5f7e8b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f7e8b2",
  null
  
)

export default component.exports